<div class="grid">
    <div class="col-12">
        <div class="card px-6 py-6">

            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                    <div class="my-2">
                        <button pButton pRipple label="Crear Compañía" icon="pi pi-plus" class="p-button mr-2" (click)="openNew()"></button>
                        <button pButton pRipple label="Eliminar Compañía" icon="pi pi-trash" class="p-button mr-2" (click)="deleteSelectedCompanies()"></button>
                    </div>
                </ng-template>
            </p-toolbar>

            <p-table [value]="companies" [columns]="cols" responsiveLayout="scroll" [rows]="10" [paginator]="true" [(selection)]="selectedCompanies" selectionMode="multiple">

                <ng-template pTemplate="caption">
                    <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                        <h5 class="m-0">Lista de Compañías</h5>
                        <span class="block mt-2 md:mt-0 p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="onGlobalFilter(dt, $event)" placeholder="Buscar..."  class="w-full sm:w-auto"/>
                        </span>
                    </div>
                </ng-template>

                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                        <th pSortableColumn="code">RUC <p-sortIcon field="ruc"></p-sortIcon></th>
                        <th pSortableColumn="code">Teléfono <p-sortIcon field="registry"></p-sortIcon></th>
                        <th pSortableColumn="code">Actividad <p-sortIcon field="actividad"></p-sortIcon></th>
                        <th pSortableColumn="code">Número de Registro <p-sortIcon field="registro"></p-sortIcon></th>
                        <th pSortableColumn="code">Acciones</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-company>
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="company"></p-tableCheckbox>
                        </td>
                        <td><span class="p-column-title">Nombre</span>
                            {{company.name}}
                        </td>
                        <td><span class="p-column-title">RUC</span>
                            {{company.nui}}
                        </td>
                        <td><span class="p-column-title">Teléfono</span>
                            {{company.phone}}
                        </td>
                        <td><span class="p-column-title">Actividad</span>
                            {{company.activity}}
                        </td>
                        <td><span class="p-column-title">Número de Registro</span>
                            {{company.registration_number}}
                        </td>
                        <td>
                            <button pButton pRipple label="Editar" icon="pi pi-pencil" class="p-button-secondary mr-2 mt-2" (click)="editSelectedCompanies(company)"></button>

                            <a [routerLink]="['/groups', uuid, 'companies', company.uuid, 'users']">
                                <button pButton pRipple label="Usuarios" icon="pi pi-users" class="p-button-info mr-2 mt-2" ></button>
                            </a>

                            <a [routerLink]="['/groups',uuid, 'companies', company.uuid, 'plans']">
                                <button pButton pRipple label="Plan" icon="pi pi-wallet" class="p-button-info mr-2 mt-2" ></button>
                            </a>
                        </td>
                    </tr>
                </ng-template>

            </p-table>

        </div>

        <p-dialog [formGroup]="form" [(visible)]="companyDialog" [style]="{width: '800px'}" header="Nueva Compañía" [modal]="true" class="p-fluid">
            <ng-template pTemplate="content">
                <div class="form-grid">
                    <div class="field">
                        <label>Nombre</label>
                        <input type="text" pInputText formControlName="name" required autofocus [ngClass]="{'ng-invalid ng-dirty' : form.get('name').touched && form.get('name').invalid}"/>
                        <small class="ng-dirty ng-invalid" *ngIf="form.get('name').touched && form.get('name').invalid">Nombre es requerido.</small>
                    </div>
                    <div class="field">
                        <label>Identificación</label>
                        <input type="text" pInputText formControlName="nui" required autofocus [ngClass]="{'ng-invalid ng-dirty' : form.get('nui').touched && form.get('nui').invalid}"/>
                        <small class="ng-dirty ng-invalid" *ngIf="form.get('nui').touched && form.get('nui').invalid">RUC es requerido.</small>
                    </div>
                    <div class="field">
                        <label>LogoIsotipo</label>
                        <input type="file" #logo accept="image/*"
                               (change)="selectFile($event)">
                    </div>
                    <div class="field">
                        <label>Dirección</label>
                        <input type="text" pInputText formControlName="address" />
                    </div>
                    <div class="field">
                        <label>Teléfono</label>
                        <input type="text" pInputText formControlName="phone"/>
                    </div>
                    <div class="field">
                        <label>Actividad</label>
                        <input type="text" pInputText formControlName="activity" />
                    </div>
                    <div class="field">
                        <label>ID Representante Legal</label>
                        <input type="text" pInputText formControlName="legal_representative_id" />
                    </div>
                    <div class="field">
                        <label>Representante Legal</label>
                        <input type="text" pInputText formControlName="legal_representative" />
                    </div>
                    <div class="field">
                        <label>Número de Empleados</label>
                        <input type="number" pInputText formControlName="employee_numbers" />

                    </div>
                    <div class="field">
                        <label>Número de Registro</label>
                        <input type="text" pInputText formControlName="registration_number" />
                    </div>
                </div>
            </ng-template>

            <ng-template pTemplate="footer">
                <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
                <button pButton pRipple label="Guardar" icon="pi pi-check" class="p-button-text" (click)="performAction()" [disabled]="isSaving"></button>
            </ng-template>
        </p-dialog>


        <p-dialog [(visible)]="deleteCompaniesDialog" header="Confirmación" [modal]="true" >
            <div class="flex align-items-center justify-content-center">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem"></i>
                <span>¿Está seguro que desea eliminar la compañía?</span>
            </div>
            <ng-template pTemplate="footer">
                <button pButton pRipple icon="pi pi-times" class="p-button-text" label="No" (click)="deleteCompaniesDialog = false"></button>
                <button pButton pRipple icon="pi pi-check" class="p-button-text" label="Si" (click)="confirmDeleteSelected()"></button>
            </ng-template>
        </p-dialog>

    </div>
</div>
